module.exports = __webpack_public_path__ + "img/kbshinya.dbd44e6d.jpg";